// @flow

import * as React from 'react';
import usePrevious from 'speed-js-react-web/src/hooks/usePrevious';
import scrollToFirstError from './hooks/scrollToFirstError';

type Props = {
    isSubmitting: boolean,
    errors: Object,
};

const ScrollToError = ({ children, isSubmitting, errors }: Props) => {
    const prevIsSubmitting = usePrevious(isSubmitting);

    React.useEffect(() => {
        if (prevIsSubmitting && !isSubmitting && errors) {
            scrollToFirstError(errors);
        }
    }, [prevIsSubmitting, isSubmitting, errors]);

    return null;
};

export default ScrollToError;
